import React, { Component } from 'react';
import { withSnackbar } from 'notistack';
// actions
import { compose } from 'redux';
import { DialogContent, FormHelperText } from '@mui/material';
import { deleteAccountAgency } from '../../accounts/AccountService';
// platform helpers
import { PubSub } from '../../utils/eventUtils';
import { withToggleModal } from '../hocs/withToggleModal';
import { withQueryClient } from '../hocs/withQueryClient';
import { AGENCY_ACCOUNTS } from '../tables/table_constants';

class AccountsDeleteConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountName: '',
      accountId: '',
      error: '',
    };
  }

  componentDidMount() {
    const {
      props: { data },
    } = this;
    this.setState({
      accountName: data.name,
      accountId: data.id,
    });
    this.subscription = PubSub.subscribe('foot-button-one', (eventData) => {
      if (eventData) {
        this.handleSubmit();
      }
    });
  }

  componentWillUnmount() {
    this.subscription.remove();
  }

  handleSubmit = () => {
    PubSub.publish('loading', true);
    PubSub.publish('disabled', true);
    deleteAccountAgency(this.state.accountId)
      .then(() => {
        PubSub.publish('loading', false);
        PubSub.publish('disabled', false);
        this.props.toggleModal.direct('AccountsDeleteConfirm', false);
        this.props.enqueueSnackbar('Account Deleted Successfully!', {
          variant: 'success',
        });
        this.props.queryClient.invalidateQueries([AGENCY_ACCOUNTS]);
      })
      .catch((error) => {
        PubSub.publish('loading', false);
        PubSub.publish('disabled', false);
        this.setState({ error: error.response.data });
      });
  };

  render() {
    return (
      <DialogContent>
        <div className="modal-title">
          Are you sure you want to delete the account
          <span className="modal-blue-text"> {this.state.accountName}</span>?
        </div>
        <FormHelperText className="api-text-error">
          {this.state.error}
        </FormHelperText>
      </DialogContent>
    );
  }
}

AccountsDeleteConfirm.defaultProps = {
  data: {},
};

export default compose(
  withSnackbar,
  withToggleModal,
  withQueryClient
)(AccountsDeleteConfirm);
